import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=0afee91a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afee91a')) {
      api.createRecord('0afee91a', component.options)
    } else {
      api.reload('0afee91a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=0afee91a&", function () {
      api.rerender('0afee91a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M3lAfT4xBSux/JS/cancellationPolicy.vue"
export default component.exports